import type { EventFor } from 'types/unpoly/events'

export const SCROLL_EVENT_NAME = 'app.scrollToVideo'

interface PlaylistData {
  video_id: string
  item_selector: string
}

up.compiler(
  '[data-mark-current-playlist-video]',
  (element: HTMLElement, { video_id: videoId, item_selector: itemSelector }: PlaylistData) => {
    const viewport = element.querySelector('[up-viewport]')!
    let video = findCurrentVideo(videoId)
    let lastScroll: number | undefined

    function scrollTo(offset: number): void {
      viewport.scrollTo({ top: offset })
    }

    function unmarkCurrentVideos(): void {
      element.querySelectorAll(`${itemSelector}.-current`).forEach((element) => {
        element.classList.remove('-current')
      })
    }

    function findCurrentVideo(videoId: string): HTMLElement | undefined {
      for (const item of element.querySelectorAll<HTMLElement>('[video-link]').values()) {
        if (up.data(item).videoId === videoId) {
          return item
        }
      }
    }

    function scrollToVideo(): void {
      const videoLinks = Array.from(element.querySelectorAll<HTMLElement>('[video-link]'))

      let index = videoLinks.indexOf(video!)
      if (index > 0) index--

      const headWrapper = element.querySelector<HTMLElement>('.playlist--head-wrapper')!
      const videoLink = videoLinks[index]
      const linkRect = videoLink.getBoundingClientRect()
      const viewportRect = (viewport as HTMLElement).getBoundingClientRect()
      const scrollOffset =
        (viewport as HTMLElement).scrollTop +
        linkRect.top -
        viewportRect.top -
        headWrapper.offsetHeight
      scrollTo(scrollOffset)
    }

    function markCurrentVideo(): void {
      video!.closest(itemSelector)!.classList.add('-current')
    }

    function update({ scroll = true } = {}): void {
      unmarkCurrentVideos()
      if (video) {
        if (scroll) {
          scrollToVideo()
        }
        markCurrentVideo()
      }
    }

    function rememberScroll(): void {
      lastScroll = (viewport as HTMLElement).scrollTop
    }

    update()

    viewport.addEventListener('scroll', () => {
      rememberScroll()
    })

    element.addEventListener(SCROLL_EVENT_NAME, () => {
      scrollToVideo()
    })

    element.addEventListener('up:fragment:keep', (event: Event) => {
      video = findCurrentVideo((event as EventFor<'up:fragment:keep'>).newData.video_id)
      update({ scroll: false })
      if (lastScroll !== undefined) {
        scrollTo(lastScroll)
      }
    })
  },
)
